import { provideZoneChangeDetection } from "@angular/core";
import { loadCoBrand, notifyPreviewRendered, renderCoBrandUnavailable } from './app/core/services/co-brand.service';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { mixpanelInit } from './app/shared/utils/mixpanel.util';
import { captureAdParams } from './app/shared/utils/gtm.util';

// ORDER IS LOAD-BEARING. mixpanelInit() registers the acquisition super-props, so the
// ad-param store must already be populated here. Capturing later (this used to run in
// app.component ngOnInit, i.e. after bootstrap) left the first $mp_web_page_view of
// every cold session with no first_* and no environment.
//
// mixpanelInit() itself fires NO pageview. Pageviews come exclusively from
// app.component's NavigationEnd handler via trackPageview() — which cannot run until
// bootstrap below has completed, so the super-props registered here are guaranteed to
// be on every pageview. Do not "restore" a bootstrap pageview: that is the duplicate
// this design removed. See the track_pageview note in mixpanel.util.ts.
captureAdParams();
mixpanelInit();

// Community (partner look) from ?community_id= or the remembered number, applied before the app
// draws anything so there is no flash of RealWorld colors. With no community the app boots
// exactly as before. See core/services/co-brand.service.ts.
loadCoBrand().then((boot) => {
  // A disabled brand (or one whose details could not be loaded) gets a branded
  // "temporarily unavailable" page instead of the app, never "page not found".
  if (boot.unavailable) {
    renderCoBrandUnavailable(boot);
    return;
  }
  return platformBrowserDynamic().bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
    .then(() => notifyPreviewRendered());
}).catch(err => console.error(err));
